<template>
    <div :class="['Input', 'InputText', { 'active': active }]">
        <div class="InputText__placeholder">{{ placeholder }}</div>
        <el-input v-if="!(name === 'telephone' || name === 'siret' || name === 'finess' || name === 'codepostal')"
                  :name="'input-' + name"
                  :id="name"
                  v-model="localModel"
                  :class="{ error: localErrors.length }"
                  v-on:focus="onFocus()"
                  v-on:blur="onBlur()"
                  :maxlength="maxlength"
                  :type="name === 'email' ? 'email' : 'text'">
        </el-input>
        <div v-if="(name === 'telephone' || name === 'siret' || name === 'finess' || name === 'codepostal')" :class="['el-input', { error: localErrors.length }]">
            <the-mask :mask="name === 'telephone' ? '## ## ## ## ##' : (name === 'siret' ? '### ### ### #####' : (name === 'finess' ? '## ### ### #' : '#####'))"
                      :placeholder="name === 'telephone' ? '__ __ __ __ __' : (name === 'siret' ? '___ ___ ___ _____' : (name === 'finess' ? '__ ___ ___ _' : '_____'))"
                      :masked="true"
                      :name="'input-' + name"
                      :id="name"
                      v-model="localModel"
                      class="el-input__inner"
                      v-on:focus="onFocus()"
                      v-on:blur="onBlur()"
                      type="tel" />
        </div>
        <div v-if="errors" class="Input__error">{{localErrors[0]}}</div>
    </div>
</template>

<style lang="sass">
    @import ../../../common/styles/mixins
    @import ../../../common/styles/settings

    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button
        -webkit-appearance: none
        margin: 0

    /* Firefox */
    input[type=number]
        -moz-appearance: textfield


    .InputText
        position: relative

        &__placeholder
            font-weight: 100
            color: transparentize($color-text, 0.2)
            position: absolute
            top: 2px
            transition: font-size $speed-fast $authentic-motion, top $speed-fast $authentic-motion
            .active &
                font-size: 0.8rem
                top: -1.1rem

        .el-input.error
            .el-input__inner
                border: 1px solid $color-base

        .el-input__inner
            background: none
            border: 0
            border-bottom: 1px solid $color-text
            border-radius: 0
            padding: 0 0 0.5rem
            font-family: Roboto, sans-serif
            font-size: 14px
            font-weight: 400


</style>

<script>
    import {TheMask} from 'vue-the-mask';

    export default {
        components: {
            TheMask
        },

        props: ["name", "value", "items", "placeholder", "errors", "maxlength"],

        data() {
            return {
                active: false,
                localModel: this.value,
                localErrors: this.errors || []
            }
        },
        watch: {
            localModel(val) {
                this.$emit("input", val);
                this.$parent.validateField(this.name);
            },
            value: function(newVal, oldVal) {
                this.localModel = newVal;
            },
            errors: function(newVal, oldVal) {
                this.localErrors = newVal || [];
            }
        },
        methods: {
            onFocus() {
                this.active = true;
            },
            onBlur: function() {
                if ( !this.localModel ) {
                    this.active = false;
                }
                this.$parent.validate();
            }
        }
    }

</script>
